import { render, staticRenderFns } from "./MyAbout.vue?vue&type=template&id=495fe698&"
import script from "./MyAbout.vue?vue&type=script&lang=js&"
export * from "./MyAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports